import ImageListItem from '@mui/material/ImageListItem';
import { useEffect, useState } from 'react';
import Carousel from "react-bootstrap/Carousel";
import NextIcon from '../../../assets/Posts/NextIcon';
import PrevButton from '../../../assets/Posts/PrevIcon';
import ThreeDotsVertical from '../../../assets/Posts/ThreeDotsVertical';
import { api } from '../../../services/api';
import DeleteModal from '../../Modals/DeleteModal';
import PostOptionsModal from '../../Modals/PostOptionsModal';
import ShareModal from '../../Modals/SharePostModal';
import PostInformation from '../PostInformation';
import SnipzPlayer from '../SnipzPlayer';

import PostModal from '../PostModal';
import {
  ImageNumber,
  PostHeader,
  TopIconWrapper,
  TriangleWrapper
} from './styles';

type FeedPostProps = {
  initiateAsModal?: boolean;
  setHidePost?: (state: boolean) => void;
  authorAvatarUrl: string;
  authorId: string,
  authorUsername: string,
  id: string,
  type: string,
  medias:
  {
    name: string,
    size: string,
    type: string,
    url: string
  }[],
  description: string[],
  tags: string[],
  likes: number,
  comments: number,
  createdAt: string,
  updatedAt: string,
  isLiked: boolean,
  feedType: string;
};

export default function FeedPost({
  initiateAsModal,
  setHidePost,
  authorAvatarUrl,
  authorId,
  authorUsername,
  id,
  type,
  medias,
  description,
  tags,
  likes,
  comments,
  createdAt,
  updatedAt,
  isLiked,
  feedType
}: FeedPostProps) {
  const [modal, setModal] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<number>(0);
  const [modalSelectedImage, setModalSelectedImage] = useState<number>(0);
  const [postModal, setPostModal] = useState<boolean>(false);
  const [shareModal, setShareModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [likesCount, setLikesCount] = useState<number>(likes)
  const [commentsCount, setCommentsCount] = useState<number>(comments)
  const [isLikedState, setIsLikedState] = useState<boolean>(isLiked)

  const handleModalActions = async (action: string) => {
    if (action === 'post') {
      setPostModal(!postModal);
    } else if (action === 'share') {
      setShareModal(!shareModal);
    } else if (action === 'delete') {
      setPostModal(false);
      setDeleteModal(!deleteModal);
    } else if (action === 'confirmDelete') {
      try {
        api.delete(`/media/publication/${id}`)
      } catch (error) {
        console.log(error)
      }
      setDeleteModal(!deleteModal);
    } else if (action === 'noDelete') {
      setDeleteModal(!deleteModal);
    }
  }

  useEffect(() => {
    if (initiateAsModal) {
      setModal(true);
    }
  }, [initiateAsModal]);

  const handleClose = () => {
    setModal(!modal);
    if (setHidePost) {
      setHidePost(false);
    }
  }

  return (
    <>
      <PostModal
        modal={modal}
        handleClose={handleClose}
        setModal={setModal}
        id={id}
        medias={medias}
        type={type}
        authorUsername={authorUsername}
        authorAvatarUrl={authorAvatarUrl}
        createdAt={createdAt}
        description={description}
        feedType={feedType}
        tags={tags}
        likes={likes}
        comments={comments}
        isLiked={isLiked}
        likesCount={likesCount}
        setLikesCount={setLikesCount}
        commentsCount={commentsCount}
        setCommentsCount={setCommentsCount}
        selectedImage={selectedImage}
        modalSelectedImage={modalSelectedImage}
        setModalSelectedImage={setModalSelectedImage}
        isLikedState={isLikedState}
        setIsLikedState={setIsLikedState}
      />
      <ImageListItem
        key={id}
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginLeft: 12,
          marginRight: 12,
          marginBottom: 24,
        }}
      >
        <PostHeader>
          {medias.length > 1 ? (
            <ImageNumber>{modal ? modalSelectedImage + 1 : selectedImage + 1}/{medias.length}</ImageNumber>
          ) : <div />}
          <TopIconWrapper onClick={() => setPostModal(!postModal)}>
            <ThreeDotsVertical />
            <PostOptionsModal open={postModal} authorUsername={authorUsername} onAction={handleModalActions} />
            {shareModal && <ShareModal authorUsername={authorUsername} id={id} open={shareModal} onClose={setShareModal} />}
            {deleteModal && <DeleteModal onAction={handleModalActions} />}
          </TopIconWrapper>
        </PostHeader>
        {type === 'snipz' ? (
          <div style={{ marginBottom: -20 }} onClick={() => setModal(!modal)}>
            <SnipzPlayer modal={false} isFeed={true} local={false} src={medias[0].url} />
          </div>
        ) : (
          <Carousel
            activeIndex={selectedImage} //problema do slide
            defaultActiveIndex={0}
            prevIcon={<PrevButton />}
            nextIcon={<NextIcon />}
            wrap={false}
            interval={null}
            slide={true}
            indicators={false}
            onSelect={(index, e) => setSelectedImage(index)}
            style={{
              objectFit: 'cover',
              borderRadius: 8,
              maxWidth: 400,
              overflow: 'hidden',
            }}
          >
            {medias.map((image, index) => (
              <Carousel.Item key={index} >
                <img
                  src={image.url}
                  loading="eager"
                  style={{ minWidth: 319, maxWidth: 400 }}
                  onClick={() => setModal(!modal)}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        )}
        <TriangleWrapper>
          <Triangle />
        </TriangleWrapper>
        <PostInformation
          id={id}
          avatar={authorAvatarUrl}
          selectedImage={selectedImage}
          authorUsername={authorUsername}
          timeSince={createdAt}
          descriptions={description}
          likes={likes}
          numberOfComments={comments}
          openModal={() => setModal(!modal)}
          liked={isLikedState}
          setLiked={setIsLikedState}
          likesCount={likesCount}
          setLikesCount={setLikesCount}
          commentsCount={commentsCount}
          setCommentsCount={setCommentsCount}
        />
      </ImageListItem>
    </>
  );
}

function Triangle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="23"
      fill="#FFF"
      viewBox="0 0 30 23"
    >
      <path fill="#FFF" d="M0 22.07v-22l30 22H0z"></path>
    </svg>
  );
}
